/** Previous, play/pause and next. */

import { type Component, Show } from 'solid-js';
import { next, previous, toggleTransport } from '../../app/commands.ts';
import { playing } from '../../state/player.ts';
import { Next, Pause, Play, Previous } from '../icons/media.tsx';
import styles from './Transport.module.css';

export const Transport: Component = () => (
  <div class={styles.transport}>
    <button
      type="button"
      class={styles.tbtn}
      title="Previous (P)"
      aria-label="Previous"
      onClick={() => void previous()}
    >
      <Previous />
    </button>

    <button
      type="button"
      class={[styles.tbtn, styles.play]}
      title="Play / pause (Space)"
      aria-label={playing() ? 'Pause' : 'Play'}
      onClick={() => void toggleTransport()}
    >
      <Show when={playing()} fallback={<Play />}>
        <Pause />
      </Show>
    </button>

    <button
      type="button"
      class={styles.tbtn}
      title="Next (N)"
      aria-label="Next"
      onClick={() => void next()}
    >
      <Next />
    </button>
  </div>
);
